import { useCustomQuery } from "@/shared/hooks/useCustomQuery";
import LearningService from "../service/learningService";
import CreatorService from '@/features/creators/services/creatorService';

export function useLearningData(id?: string, isEditing?: boolean) {
    const { data: creators, isLoading: isLoadingCreators } = useCustomQuery({
        serviceInstance: CreatorService.Instance,
        selectAction: (s) => s.getCreators,
        parameter: undefined,
    });



    const { data: learningsContents, isLoading: isLoadingLearningsContents } = useCustomQuery({
        serviceInstance: LearningService.Instance,
        selectAction: (s) => s.getLearningsContent,
        parameter: { id: id! },
        options: { enabled: isEditing && !!id }
    });

    return {
        creators,
        isLoadingCreators,
        learningsContents,
        isLoadingLearningsContents
    };
}
